/**
 * Created by Ning Jiang on 2021-05-03.
 */

import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap} from "gsap";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";

export class SerialSound {
    public static AS_WIN:string="asWin";
    public static AS_WIN_BIG:string="asWinBig";

    public static MAIN_GAME_MUSIC:string = "background-music-main";
    public static FREESPIN_MUSIC:string = "background-music-freespin";
    public static FREESPIN_SUPER_MUSIC:string = "background-music-superfreespin";

    public static PHONE_INTRO:string = "phoneIntro";
    public static PHONE_INTRO_FS:string = "phoneIntroFS";
    public static PHONE_INTRO_FS_SUPER:string = "phoneIntroSFS";

    public static REELS_SPINNING:string = "reelsSpinning";
    public static REELS_SPINNING_FS:string = "reelsSpinningFSSFS";

    public static REELS_LANDING:string = "reelLanding1";
    public static REELS_LANDING_FS:string = "reelLanding2";
    public static REELS_LANDING_ENHANCER:string = "reelLandingEnhancer";

    public static WIN_HIGHLIGHT:string = "winHighlight";
    public static WIN_HIGHLIGHT_FS:string = "winHighlightFSSFS";
    public static WIN_SOUNDS:string[] = ["winTiny", "winSmall", "winMediumCountUp", "winLargeCountUp"];
    public static WIN_END_SOUNDS:string[] = ["", "", "winMediumEnd", "winLargeEnd"];
    public static PRE_BIG_WIN:string = "preBigWin";
    public static BIG_WIN:string[] = ["bigWinLevel1", "bigWinLevel2", "bigWinLevel3", "bigWinLevel4", "bigWinLevel5"];
    public static BIG_WIN_LEVEL_CHANGE:string = "bigwinLevelChange";
    public static BIG_WIN_END:string = "bigwinEnds";
    public static ANTICIPATION_BIG_WIN:string = "preBigWinAnticipation";

    public static ANTICIPATION:string[] = ["anticipation1", "anticipation2"];
    public static ANTICIPATION_FAIL:string = "anticipationFail";
    public static ANTICIPATION_REEL_STOP:string = "anticipationReelStop";

    public static WILD_LANDING:string = "wildLanding";
    public static NUDGE_LANDING:string = "xNudgeLanding";
    public static NUDGE:string = "xNudgeMovement";
    public static NUDGE_NO_WIN:string = "xNudgeMovement";
    public static NUDGE_SKIP:string = "xNudgeMovement";

    public static XWAYS_LANDING:string = "xWaysLand";
    public static XWAYS_REVEAL:string = "xWaysReveal";
    public static SCATTER_TO_XWAYS:string = "scatterGoingXways";

    public static SCATTERS:string[] = ["scatter1", "scatter2", "scatter3", "scatter4"];
    public static SCATTERS_WIN:string = "scattersGoDead";
    public static SCATTER_PLUS:string = "plus";

    public static ENHANCER_OPEN:string[] = ["tapeOff1", "tapeOff2", "tapeOff3", "tapeOff4", "tapeOff5"];
    public static ENHANCER_CLOSE:string = "tapeOn";

    public static FS_TRANSITION:string = "preFSIntro";

    public static FS_INTRO_LOOP:string = "fsIntro";
    public static SFS_INTRO_LOOP:string = "sfsIntro";

    public static FS_OUTRO:string = "fsSfsSummaryInitialImpact";
    public static FS_OUTRO_COUNTUP:string = "fsSfsSummaryLoop";
    public static FS_OUTRO_COUNTUP_END:string = "fsSfsSummaryEnd";

    public static CONTINUE_FS_INTRO:string = "continueButtonToFSSFS";
    public static CONTINUE_FS_OUTRO:string = "continueButtonBackToMainGameFromFSSFS";
    public static CONTINUE_FS_OUTRO_BONUS_BUY:string = "continueButtonBackToMainGameFromBonusBuy";

    public static WIN_CAP_LOOP:string[] = ["winCapLoopLevel1", "winCapLoopLevel2", "winCapLoopLevel3", "winCapLoopLevel4"];
    public static WIN_CAP_CLICK:string = "winCapChangeLevelClick";
    public static WIN_CAP_TRANSITION_LOOP:string = "winCapStaticLoop";
    public static WIN_CAP_END:string = "winCapEnd";
    public static WIN_CAP_LEVEL_RIGHT:string[] = ["", "winCapLevel1Continue", "winCapDoorCorrect", "winCapToiletCorrect"];
    public static WIN_CAP_LEVEL_WRONG:string[] = ["", "winCapEmptyTent", "winCapDoorWrong", "winCapToiletWrong"];
    public static WIN_CAP_LEVEL_INTRO:string [] = ["winCapRoad", "winCapBizarrePosting", "", ""];
    public static WIN_CAP_MAX_WIN:string = "winCapLevel4InitialImpact";

    public static X_SPLIT:string = "split";
    public static X_SPLIT_MOVE:string = "chainsawMovementLastReel";
    public static X_SPLIT_MOVE_END:string = "chainsawMovementLastReelStop";

    public static XBET_ON:string = "xBetOn";
    public static XBET_OFF:string = "xBetOff";
    public static XBET_IDLE:string = "xBetIdle";

    public static INFECTIOUS_LAND:string = "infectiousWaysXLand";
    public static INFECTIOUS_INFECT:string = "infectiousWaysSplit";

    public static PLAYING_LOOP_EFFECT:string = "";

    public static get soundPlayer():NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        if(NolimitConfig.isDevMode) {
            SerialSound.soundPlayer.showLogs(true);
        }
        NolimitSlotAudio.apiPlugIn.settings.on(APISetting.SFX, (value:any) => this.onSFX(value));
    }

    private onSFX(value:any):void {
        if(!SerialSound.soundPlayer.isLoaded) {
            return;
        }
        if(!NolimitSlotAudio.apiPlugIn.settings.get("mute")) {
            return;
        }
        if(!value) {
            return;
        }
        if(SerialSound.PLAYING_LOOP_EFFECT.length > 0) {
            const player = SerialSound.soundPlayer.fetchSoundPlayer(SerialSound.PLAYING_LOOP_EFFECT);
            if(player && !player.isPlaying) {
                SerialSound.soundPlayer.playTrack({name : SerialSound.PLAYING_LOOP_EFFECT, repeat : 1000});
            }
        }
    }

    private static _currentMusic:string;

    public static switchMusic(conf:IPlayTrackConf, fadeInConf?:IFadeTrackConf, fadeOutConf?:IFadeTrackConf):void {
        if(conf.name === SerialSound._currentMusic) {
            return;
        }

        if(SerialSound._currentMusic != null) {
            if(fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = SerialSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if(fade) {
                    gsap.to(this, {
                        duration : fadeOutConf.duration / 1000,
                        onComplete : () => {SerialSound.soundPlayer.stopTrack(fadeName)}
                    });
                } else {
                    SerialSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                SerialSound.soundPlayer.stopTrack(SerialSound._currentMusic);
            }
        }

        SerialSound.soundPlayer.playTrack(conf);
        if(fadeInConf) {
            SerialSound.soundPlayer.fadeTrack(fadeInConf);
        }
        SerialSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol:number, duration:number):void {
        SerialSound.soundPlayer.fadeTrack({
            name : SerialSound._currentMusic,
            to : vol,
            duration : duration
        });
    }

    public static getMusicNameByMode(mode:GameMode | string):string {
        switch(mode) {
            case GameMode.FREESPIN:
                // return SerialSound.FREESPIN;
                return SerialSound.MAIN_GAME_MUSIC;
            default:
                return SerialSound.MAIN_GAME_MUSIC;
        }
    }

    public static fadeAndStopSound(fadeOutConf:IFadeTrackConf):void {
        const fade = SerialSound.soundPlayer.fadeTrack(fadeOutConf);
        if(fade) {
            gsap.to(this, {
                duration : fadeOutConf.duration / 1000,
                onComplete : () => {SerialSound.soundPlayer.stopTrack(fadeOutConf.name)}
            });
        } else {
            SerialSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }
}